import React from 'react';
import { fillThemeColor, getThemeColor } from './Base';
import { getHelpIcon, parseHelp } from './Help';
import Tooltip from './Tooltip';


export default class Badge extends React.Component {

    constructor(props) {
        super(props);
    }



    renderMain() {
        let { color, textColor, style, size, className, pill, outline, theme, bold,height,width } = this.props;
        let p = { ...this.props };
        delete p.textColor; delete p.size; delete p.pill; delete p.color; delete p.outline; delete p.theme; delete p.bold;delete p.height;delete p.width;
        size = (height || width) ? "none": size;//如果手工指定了高或宽，那么size无效了

        if (theme) {
            p.className = `c-badge-theme c-badge-theme-${size} ${bold ? 'c-badge-bold' : ''} ${theme === true ? '' : `c-badge-${theme}`} ${className}`;
            p.style = { height,width,...p.style};
        }
        else if (outline) {
            color = getThemeColor(color, "value");
            p.className = `badge c-badge c-badge-${size} ${pill ? 'c-badge-pill' : ''} ${bold ? 'c-badge-bold' : ''} ${outline ? 'c-badge-outline' : ''} ${className}`;
            p.style = { height,width, ...p.style, color, borderColor: color, borderWidth: this.getBorderWidth(size) };
        }
        else {
            let textClassName = getThemeColor(textColor, "text");
            p.className = `badge c-badge c-badge-${size} ${pill ? 'c-badge-pill' : ''} ${bold ? 'c-badge-bold' : ''} ${textClassName} ${className}`;
            p.style = { height,width,...p.style};
            if (!color) color = getThemeColor("grey-system", "value");
            fillThemeColor(p, color, true);
        }

        return <span {...p}></span>;
    }

    getBorderWidth(size) {
        switch (size) {
            case "md": return 1;
        }
        return 1;
    }

    render(){
        let {help} = this.props;
        help=parseHelp(help);
        if(help){
            return Tooltip({
                description:help.message,
                placement:help.placement||"left",
                content:(this.renderMain())
            });
        }
        return this.renderMain();
    }

}


Badge.defaultProps = {
    className: '',
    color: 'primary',
    textColor: "white",
    size: "md",
    pill: false
}